import { useTranslation } from 'react-i18next';

import { type BaseCurrencyType, type SupportedWalletType } from '@pkg/types';

import { ImgLogoLedger, ImgLogoMetaMask, ImgLogoPetra, ImgLogoWalletConnect } from './assets';

const supportedCurrencies: Record<SupportedWalletType, BaseCurrencyType[]> = {
    'wallet-connect': ['eth', 'matic'],
    metamask: ['eth'],
    ledger: ['eth', 'matic'],
    petra: ['apt'],
};

const walletImages: Record<SupportedWalletType, string> = {
    'wallet-connect': ImgLogoWalletConnect,
    metamask: ImgLogoMetaMask,
    ledger: ImgLogoLedger,
    petra: ImgLogoPetra,
};

export function useWalletOptionDetails(type: SupportedWalletType) {
    const [translate] = useTranslation('wallet');

    function getWalletName() {
        switch (type) {
            case 'metamask':
                return translate('option-metamask');
            case 'ledger':
                return translate('option-ledger');
            case 'petra':
                return translate('option-petra');
            default:
                return translate('option-wallet-connect');
        }
    }

    return {
        name: getWalletName(),
        image: walletImages[type],
        currencies: supportedCurrencies[type],
    };
}
